// extracted by mini-css-extract-plugin
export default {"header":"DataSources_header__sgA3p","dataSourcesHeader":"DataSources_dataSourcesHeader__YiaPz","font":"DataSources_font__urKA0","section":"DataSources_section__LHWko"};